// extracted by mini-css-extract-plugin
export default {"box":"AreaBig_box__-6C11","info":"AreaBig_info__bbCdg","info_wrap":"AreaBig_info_wrap__jVLQ+","content":"AreaBig_content__sYHtB"};